import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormGroup, Input, Label } from 'reactstrap';

import RequiredStarLabel from '../../../../components/common/requiredStarLabel';
import FormGroupNote from '../../../../components/form/FormGroupNote';

export default function ConsumerTypeDimmableCheckbox({
  isDisabled,
  isRequired = false
}) {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <FormGroup className="d-flex align-items-center">
      <Label htmlFor="dimmable" className="m-0 mr-2">
        {t('Is Dimmable')} {isRequired && <RequiredStarLabel />}
      </Label>
      <Controller
        name="dimmable"
        control={control}
        render={({ field }) => (
          <Input
            id="dimmable"
            type="checkbox"
            {...field}
            checked={!!field.value}
            className="m-0 position-static"
            disabled={isDisabled}
          />
        )}
      />
      {errors.dimmable && (
        <FormGroupNote type="warning">{errors.dimmable.message}</FormGroupNote>
      )}
    </FormGroup>
  );
}
